<div class="app-toolbar-container" [ngClass]="{ 'app-toolbar-container-non-prod': !isProduction }">
  <div class="app-toolbar-container-content" fxLayout="row" fxLayoutAlign="space-between center">
    <mat-tab-group
      class="app-toolbar-container-content-tabs"
      (selectedTabChange)="selectedTabChanged($event)"
      [selectedIndex]="selectedTab"
    >
      <mat-tab
        *ngIf="isViewInvoiceVisible"
        label="{{ appHeaderLabels.VIEW_INVOICE }}"></mat-tab>

      <mat-tab
        *ngIf="isReleaseInvoicesVisible && !hideReleaseInvoicesTab"
        label="{{ appHeaderLabels.RELEASE_INVOICES }}"></mat-tab>

      <mat-tab
        *ngIf="isResendInvoicesVisible && !hideResendInvoicesTab"
        label="{{ appHeaderLabels.RESEND_INVOICES }}"></mat-tab>

      <mat-tab
        *ngIf="isRFCManagementVisible && !hideRFCManagementTab"
        label="{{ appHeaderLabels.RFC_MANAGEMENT }}"></mat-tab>
    </mat-tab-group>
  </div>
</div>
